import {
  CheckCircle2,
  Archive,
  FileText,
  XCircle,
} from '@spcc/uikit'
import type { SalesOrderStatus } from '../../../domain/types'

function hashString(input: string): number {
  let hash = 0
  for (let i = 0; i < input.length; i++) {
    hash = ((hash << 5) - hash) + input.charCodeAt(i)
    hash |= 0
  }
  return Math.abs(hash)
}

export function getProductColorStyles(code: string) {
  const safe = code || 'product'
  const hue = hashString(safe) % 360
  const text = `hsl(${hue} 70% 42%)`
  const dot = `hsl(${hue} 75% 50%)`
  const bg = `hsla(${hue} 80% 55% / 0.12)`
  return { bg, text, dot }
}

export const statusConfig: Record<SalesOrderStatus, {
  bg: string
  text: string
  gradient: string
  icon: typeof CheckCircle2
  dotColor: string
}> = {
  active: {
    bg: 'bg-emerald-50 dark:bg-emerald-500/10',
    text: 'text-emerald-700 dark:text-emerald-400',
    gradient: 'from-emerald-500 to-emerald-600',
    icon: CheckCircle2,
    dotColor: 'bg-emerald-500',
  },
  completed: {
    bg: 'bg-indigo-50 dark:bg-indigo-500/10',
    text: 'text-indigo-700 dark:text-indigo-400',
    gradient: 'from-indigo-500 to-indigo-600',
    icon: Archive,
    dotColor: 'bg-indigo-500',
  },
  draft: {
    bg: 'bg-slate-100 dark:bg-slate-800/50',
    text: 'text-slate-700 dark:text-slate-300',
    gradient: 'from-slate-500 to-slate-600',
    icon: FileText,
    dotColor: 'bg-slate-500',
  },
  canceled: {
    bg: 'bg-red-50 dark:bg-red-500/10',
    text: 'text-red-700 dark:text-red-400',
    gradient: 'from-red-500 to-red-600',
    icon: XCircle,
    dotColor: 'bg-red-500',
  },
}
